module.exports = __webpack_public_path__ + "images/template-create-popover-icon.345574dca58c7c6ceda0.svg";